/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PvhReasonCodeOption, PvhScanChamberService, PvhScanChamberStateInfoDto } from "app/services/pvh.scan-chamber.service";

/**
 * Resolves the available reason code options that can be applied to an attempt being
 * processed by a Scan Chamber
 */
@Injectable()
export class PvhScanChamberReasonCodesResolver implements Resolve<PvhReasonCodeOption[]> {

  /** Constructor */
  constructor(
    private pvhService: PvhScanChamberService
  ) {}

  /** Obtains the data to be resolved in the background. */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PvhReasonCodeOption[]> {
    // Call the API to retrieve the available Reason Code Options
    return await this.pvhService.getReasonCodeOptions();
  }

}
